export const dictionaryType = [
  { codeType: 'CarKind' }, // 车辆种类
  { codeType: 'IdentifyType' }, // 证件类型-个人
  { codeType: 'IdentifyTypeUnit' }, // 证件类型-单位
  { codeType: 'UseNature' }, // 车辆使用性质-车险部分
  { codeType: 'PolicyDocType' }, // 保单类型
  { codeType: 'InvoiceDocType' }, // 发票类型
  { codeType: 'DocumentsType' }, // 影像信息中的清单类型-车险
  { codeType: 'LicenseColor' }, // 号牌底色
  { codeType: 'LicenseKindCode' }, // 号牌种类
  { codeType: 'ArbitBoardName' }, // 争议方式
  { codeType: 'CarPersonalIndentifyType' }, // 车险个人证件类型
  { codeType: 'CarBusinessIndentifyType' }, // 车险企业证件类型
  { codeType: 'NonCarPersonalIndentifyType' }, // 非车个人证件类型
  { codeType: 'NonCarBusinessIndentifyType' }, // 非车企业证件类型
  { codeType: 'UnitProperties' } // 单位性质
]

export const carObject = {
  carKindCode: 'A0',
  useNatureCode: '85',
  licenseColorCode: '01',
  licenseKindCode: '02',
  chgOwnerFlag: '0',
  carKindDetailId: 'KA',
  oriCarKindName: 'K33',
  loanVehicleFlag: '0'
}
export const reminder = {
  licenseNo: '车牌号',
  brandName: '车辆型号',
  carKindCode: '车辆种类',
  useNatureCode: '车辆使用性质',
  vINNo: '车架号',
  engineNo: '发动机号',
  enrollDate: '注册日期',
  updateEnrollDate: '注册日期调整',
  issueDate: '发证日期',
  licenseColorCode: '号牌底色',
  licenseKindCode: '号牌种类',
  oriCarKindName: '行驶证车辆类型',
  oriModelName: '厂牌车型',
  // platVehicleCode: '行业车型编码',
  purchasePrice: '新车购置价',
  seatCount: '座位数',
  tonCount: '吨位数',
  power: '功率',
  vehicleId: '车辆ID'
}
export const motorReminder = {
  licenseNo: '车牌号',
  brandName: '品牌型号',
  oriModelName: '厂牌车型',
  vINNo: '车架号',
  engineNo: '发动机号',
  enrollDate: '注册日期',
  updateEnrollDate: '注册日期调整',
  carKindCode: '车辆种类',
  printModelName: '打印车型',
  carKindDetailId: '车种明细',
  seatCount: '座位数',
  exhaustCapacity: '排量',
  power: '功率',
  tonCount: '吨位',
  completekerbmass: '整备质量',
  purchasePrice: '新车购置价',
  licenseKindCode: '号牌种类',
  licenseColorCode: '号牌底色',
  oriCarKindName: '车辆类型',
  vehicleId: '车辆ID'
}
export const newCarKind = {
  saleAreaCode: '所在地市', // 新车销售公司所在地市代码，广东（非深圳）新车必录
  saleAreaName: '所在地市', // 新车销售公司所在地市名称
  saleCompany: '新车销售公司', // 新车销售公司名称，广东（非深圳）新车必录
  saleProvinceCode: '所在地市', // 新车销售公司所在省代码
  saleProvinceName: '所在地市'
}
// 北京地区能源种类
export const BeijingFuelType = [
  {
    code: 'A',
    text: '汽油'
  }, {
    code: 'B',
    value: '柴油'
  }, {
    code: 'C',
    value: '电'
  }, {
    code: 'D',
    value: '混合油'
  }, {
    code: 'E',
    value: '天然气'
  }, {
    code: 'F',
    value: '液化石油气'
  }, {
    code: 'L',
    value: '甲醇'
  }, {
    code: 'M',
    text: '乙醇'
  }, {
    code: 'N',
    text: '太阳能'
  }, {
    code: 'O',
    text: '混合动力'
  }, {
    code: 'Y',
    text: '无'
  }, {
    code: 'Z',
    text: '其他'
  }

]

// 其他地区能源种类
export const otherFuelType = [
  {
    code: '0',
    text: '燃油'
  }, {
    code: '1',
    text: '纯电力'
  }, {
    code: '2',
    text: '燃料电池'
  }, {
    code: '3',
    text: '插电式混合动力'
  }, {
    code: '4',
    text: '其他混合动力'
  }
]

// 身份信息页
export const identifyTypesList = [
  { codeType: 'CarPersonalIndentifyType' },
  { codeType: 'CarBusinessIndentifyType' },
  { codeType: 'UnitProperties' }
]

export const identifyTypeOne = [
  {
    text: '身份证',
    code: '01'
  }, {
    text: '护照',
    code: '02'
  }, {
    text: '军人证',
    code: '03'
  }
]

export const identifyTypeTwo = [{
  text: '组织机构代码',
  code: '10'
}, {
  text: '工商注册号码',
  code: '11'
}]

// 报价页面
export const taxationTypes = [
  {
    code: '1',
    text: '正常缴税'
  },
  {
    code: '2',
    text: '免税'
  },
  {
    code: '3',
    text: '减税'
  },
  {
    code: '4',
    text: '完税'
  },
  {
    code: '5',
    text: '不征'
  }
]

export const estimatesList = [
  {
    name: '完税凭证号',
    value: 'paidFreeCertificate'
  },
  {
    name: '开具凭证的税务机关名称',
    value: 'taxComName'
  },
  {
    name: '完税凭证填发日期',
    value: 'taxDocumentDate'
  },
  {
    name: '完税金额',
    value: 'SumPayTax'
  },
  {
    name: '开具完税凭证地区名称',
    value: 'taxPaidAreaCode'
  }
  // {
  //   name: '开具税务机关代码',
  //   value: 'taxComCode'
  // }
]

export const motorBaseCode = {
  MOTOR_CI_RISKCODE: '0591', // 交强险Code
  MOTOR_CI_KIND_NAME: '摩托车交通事故责任强制保险',
  MOTORCYCLE_TWO_WHEELED: 'M0', // 二轮摩托车
  MOTORCYCLE_THREE_WHEELED: 'M2', // 三轮摩托车
  MOTOR_PRODUCTCODE: 'BZ', // 交强险的producttype
  MOTOR_DATA_TYPE_CI: 'CI' // 交强险的datetype
}

export const itemKindList = [
  {
    amount: '200000', // 保额
    basePremium: null, // 基础保费
    benchMarkPremium: null, // 基准保费
    calculateFlag: null, // 是否计入保额
    deductibleRate: null, // 免赔率
    discount: null, // 折扣系数
    flag: null, // 标志字段（主险、附加险）
    kindCode: 'BZ', // 险别代码
    kindName: '摩托车交通事故责任强制保险', // 险别名称
    modeCode: null, // 玻璃单独破碎险必录
    modeName: null, // 投保方式名称
    premium: null, // 实交保费(包含不计免赔保费)
    quantity: null, // 座位数/天数
    rate: null, // 费率
    riskCode: '0591', // 险种代码
    unitAmount: null, // 每座保额/日赔偿金
    value: null // 机动车损失保险必录0 、300、 500、 1000、 2000五个选项，默认为0
  }
]

export const areaCodeObj = {
  'HE_NAN': 'HNInsureMotor',
  'SHAAN_XI': 'SHXInsureMotor',
  'HE_BEI': 'HBInsureMotor',
  'HE_BEI_02': 'HBInsureMotor_02',
  'FU_JIAN': 'FJInsureMotor',
  'NING_BO': 'NBInsureMotor',
  'XIA_MEN': 'XMInsureMotor',
  'SHAN_XI': 'SHANXIInsureMotor',
  'HU_NAN': 'HUNANInsureMotor'
}

export const motorCodeObj = {
  'HE_NANCode': '/app/mall/car-proposal/#/motor/motorLogin',
  'SHAAN_XICode': '/app/mall/car-proposal/#/motor/motorLogin?areaName=SHAAN_XI',
  'HE_BEICode': '/app/mall/car-proposal/#/motor/motorLogin?areaName=HE_BEI',
  'HE_BEI_02Code': '/app/mall/car-proposal/#/motor/motorLogin?areaName=HE_BEI_02',
  'FU_JIANCode': '/app/mall/car-proposal/#/motor/motorLogin?areaName=FU_JIAN',
  'NING_BOCode': '/app/mall/car-proposal/#/motor/motorLogin?areaName=NING_BO',
  'XIA_MENCode': '/app/mall/car-proposal/#/motor/motorLogin?areaName=XIA_MEN',
  'SHAN_XICode': '/app/mall/car-proposal/#/motor/motorLogin?areaName=SHAN_XI',
  'HU_NANCode': '/app/mall/car-proposal/#/motor/motorLogin?areaName=HU_NAN'
}

export const areaDetail = [
  {
    comName: 'HE_NAN',
    comCode: '410000',
    licenseNoName: '豫',
    isShowOCR: true
  },
  {
    comName: 'SHAAN_XI',
    comCode: '610000',
    licenseNoName: '陕',
    isShowOCR: false
  },
  {
    comName: 'HE_BEI',
    comCode: '130000',
    licenseNoName: '冀',
    isShowOCR: false
  },
  {
    comName: 'HE_BEI_02',
    comCode: '130000',
    licenseNoName: '冀',
    isShowOCR: true
  },
  {
    comName: 'FU_JIAN',
    comCode: '350000',
    licenseNoName: '闽',
    isShowOCR: true
  },
  {
    comName: 'NING_BO',
    comCode: '330000',
    licenseNoName: '浙',
    isShowOCR: true
  },
  {
    comName: 'XIA_MEN',
    comCode: '350000',
    licenseNoName: '闽',
    isShowOCR: true
  },
  {
    comName: 'SHAN_XI',
    comCode: '140000',
    licenseNoName: '晋',
    isShowOCR: true
  },
  {
    comName: 'HU_NAN',
    comCode: '430000',
    licenseNoName: '湘',
    isShowOCR: true
  }
]



// WEBPACK FOOTER //
// ./src/utils/const.js